import React, { useState } from "react";
import CustomTooltip from "../../../../components/CustomTooltip";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faEdit, faEye, faTrash } from "@fortawesome/free-solid-svg-icons";
import TrainingDetailsPopup from "./TrainingDetailsPopup";

const TrainingActionButton = ({
  id,
  setEdit,
  setTrainingId,
  assessment=false,
  toggleShowAddEditTraining,
  toggleShowDelete,
}) => {
  const [showView, setShowView] = useState(false);

  const toggleShowModal = () => {
    setShowView(!showView);
  };
  return (
    <>
      <span className="flex items-center gap-2 justify-center">
        <CustomTooltip message={"View"}>
          <span>
            <FontAwesomeIcon
              onClick={toggleShowModal}
              icon={faEye}
              size="1x"
              data-toggle="modal"
              data-target="#clientDetail"
            />
          </span>
        </CustomTooltip>
        <span>/</span>
        <CustomTooltip message={"Edit"}>
          <span>
            <FontAwesomeIcon
              icon={faEdit}
              size="1x"
              onClick={() => {
                setEdit(true);
                toggleShowAddEditTraining();
                setTrainingId(id);
              }}
            />
          </span>
        </CustomTooltip>
        <span>/</span>
        <CustomTooltip message={"Delete"}>
          <span>
            <FontAwesomeIcon
              icon={faTrash}
              size="1x"
              onClick={() => {
                setTrainingId(id);
                toggleShowDelete();
              }}
            />
          </span>
        </CustomTooltip>
      </span>
      {showView && (
        <TrainingDetailsPopup
          showView={showView}
          trainingId={id}
          assessment={assessment}
          toggleShowModal={toggleShowModal}
          setShowView={setShowView}
        />
      )}
    </>
  );
};

export default TrainingActionButton;
